import React, { useState, useEffect, useRef } from 'react';
import { OverlayTrigger, Tooltip, Alert,Form,Col,Row,InputGroup } from 'react-bootstrap';
import { Modal, Button } from 'react-bootstrap';
import { useLocation, useParams, Link } from 'react-router-dom';
import './ArticleDetail.css';
import config from "../../config";  
import { getDetailLink, stripInlineFontFamilyFromHtml, titleUrlDeleteBaskSpace } from "../../utils/utilFunctions";
import { getItemById,getItemList, getItemByOldTitle, getItemImagesByItemId, getItemVideosByItemId, getItemLangByItemId, getItemListSize, getItemPublicPDFByIdApi, getItemPublicWORDByIdApi, postCommentItem, putUpdateItem, putUpdateItemViewCount } from "../../api";

const READING_FONT_MIN = 14;
const READING_FONT_MAX = 30;
const READING_FONT_STEP = 1;
const READING_LS_FONT = 'tugikip_article_reading_font';
const READING_LS_THEME = 'tugikip_article_reading_theme';

const READING_THEMES = [
    { id: 'white', color: '#ffffff' },
    { id: 'cream', color: '#f5f1e8' },
];

const ArticleDetail = () => {
    const [showInfo, setShowInfo] = useState(false);
    const [showQuote, setShowQuote] = useState(false);
    const [citationStyle, setCitationStyle] = useState('mla');
    const [citationCopied, setCitationCopied] = useState(false);
    const [showImageModal, setShowImageModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [imageScale, setImageScale] = useState(1);
    const [imagePosition, setImagePosition] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);
    const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
    const location = useLocation();
    const [isPdfDownloading, setIsPdfDownloading] = useState(false);
    const [item, setItem] = useState({});
    const [relationItemLoading, setRelationItemLoading] = useState(false);
    const [relationItemList, setRelationItemList] = useState([]);
    const [relationStatus, setRelationStatus] = useState(false);
    const [imageList, setImageList] = useState([]);
    const [videoList, setVideoList] = useState([]);
    const [showVideoModal, setShowVideoModal] = useState(false);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
    const videoPlayerRef = useRef(null);
    const [langItemList, setLangItemList] = useState([]);
    const [langList, setLangList] = useState([]);
    const [modalShow, setModalShow] = useState(false);

    const [readingPanelOpen, setReadingPanelOpen] = useState(true);
    const [customFontSize, setCustomFontSize] = useState(() => {
        try {
            const n = parseInt(localStorage.getItem(READING_LS_FONT), 10);
            if (!Number.isNaN(n)) return Math.min(READING_FONT_MAX, Math.max(READING_FONT_MIN, n));
        } catch (_) { /* ignore */ }
        return 18;
    });
    const [readingThemeId, setReadingThemeId] = useState(() => {
        try {
            const id = localStorage.getItem(READING_LS_THEME);
            if (READING_THEMES.some((t) => t.id === id)) return id;
        } catch (_) { /* ignore */ }
        return 'white';
    });

    const readingBgColor = READING_THEMES.find((t) => t.id === readingThemeId)?.color ?? '#ffffff';

    useEffect(() => {
        try {
            localStorage.setItem(READING_LS_FONT, String(customFontSize));
        } catch (_) { /* ignore */ }
    }, [customFontSize]);

    useEffect(() => {
        try {
            localStorage.setItem(READING_LS_THEME, readingThemeId);
        } catch (_) { /* ignore */ }
    }, [readingThemeId]);

    const adjustReadingFontSize = (delta) => {
        setCustomFontSize((prev) =>
            Math.min(READING_FONT_MAX, Math.max(READING_FONT_MIN, prev + delta * READING_FONT_STEP))
        );
    };

    const params = useParams()
    const {id,oldTitle} = params; 
    const getAPI = async () => {
        //console.log('params ', params )
     
        const res = id !== undefined ? await getItemById(id) : await getItemByOldTitle(oldTitle);
        console.log('res ', res )
        if (res.status) {
            setItem(res.data);
            const tempItem = res.data;
            setRelationItemLoading(true);
            setRelationStatus(tempItem.relationItems !== "")
            const res3 = await getItemImagesByItemId(tempItem.id);
            console.log('res3 ', res3 )
            if (res3.status)
                setImageList(res3.data);
            else
                setImageList([]);

            try {
                const resVideos = await getItemVideosByItemId(tempItem.id);
                if (resVideos.status)
                    setVideoList(Array.isArray(resVideos.data) ? resVideos.data : []);
                else
                    setVideoList([]);
            } catch (_) {
                setVideoList([]);
            }

            //console.log('tempItem', tempItem)
            if (tempItem.relationItems === "") {
                setRelationItemLoading(true);
                const res1 = await getItemListSize(8);
                setRelationItemList(res1.data);
                setRelationItemLoading(false);
                setRelationStatus(false)
            }
            else {
                setRelationItemList(JSON.parse(tempItem.relationItems));
                setRelationStatus(true)
                setRelationItemLoading(false);
            }
console.log('tempItem ', tempItem )
            if (tempItem.lang !== "" && tempItem.isMultiLang === 1) {

                const res1 = await getItemLangByItemId(tempItem.id);


                if (tempItem.lang === "Türkçe") {
                    setLangList(["Türkçe", ...res1.data.map(x => x.lang)]);
                    setLangItemList([{ lang: "Türkçe", langItemText: tempItem.itemText }, ...res1.data])
                } else {
                    let tr = res1.data.find(x => x.lang === "Türkçe");
                    setLangList(["Türkçe", tempItem.lang, ...res1.data.filter(x => x.lang !== "Türkçe").map(x => x.lang)]);
                    setLangItemList([tr, { lang: tempItem.lang, langItemText: tempItem.itemText }, ...res1.data.filter(x => x.lang !== "Türkçe")])
                }

                // setLangItemList(tlist);
            }
        }






    }
    useEffect(() => {
        //console.log('id ', id )
        if (id !== undefined)
            getAPI();
    }, [id])

    useEffect(() => {
        //console.log('oldTitle ', oldTitle )
        if (oldTitle !== undefined)
            getAPI();
    }, [oldTitle])

    const onClickDownload = async(type,lang="tr")=>{
        const selectedLang = { id:1 , langTitle:"Türkçe" }
        if(type==="PDF")
        {
            try {
                setIsPdfDownloading(true);
                const pdfFile = await getItemPublicPDFByIdApi(item.id , lang,selectedLang.id);
          
                const fileUrl = URL.createObjectURL(pdfFile);
                //console.log("item ",item)
                
                 let a = document.createElement('a');
                      a.href = fileUrl;
                      a.target="_blank";
                      a.download =  (lang === "tr" ?  item.title : selectedLang.langTitle) +'.pdf';
                      a.click();
            } catch (error) {
                console.error('PDF indirme hatası:', error);
                alert('PDF indirilirken bir hata oluştu.');
            } finally {
                setIsPdfDownloading(false);
            }
        }
    };
 
    const getItemUrl = (item) => {
        return `${window.location.origin}/article/${item.id}`;
      };

      const handlePrint = () => {
        document.querySelectorAll('.article-detail-container img[loading="lazy"]').forEach((img) => {
            img.removeAttribute('loading');
            if (img.dataset.src && !img.getAttribute('src')) {
                img.setAttribute('src', img.dataset.src);
            }
        });
        window.print();
    };
    const FeedbackModal = (props) => {
        const {item} = props;
  
        const [nameSurname, setNameSurname] = useState("");
        const [mail, setMail] = useState("");
        const [comment, setComment] = useState("");
        const [phone, setPhone] = useState("");
        const [captchaData, setCaptchaData] = useState({ text: '', answer: '' });
        const [userCaptchaInput, setUserCaptchaInput] = useState("");
        const [captchaAttempts, setCaptchaAttempts] = useState(0);
        const [isBlocked, setIsBlocked] = useState(false);
        const [blockUntil, setBlockUntil] = useState(0);
        const [lastSubmission, setLastSubmission] = useState(0);
  
        // Gelişmiş matematik captcha oluştur
        const generateAdvancedCaptcha = () => {
          const operations = [
            { op: '+', fn: (a, b) => a + b, maxA: 50, maxB: 30 },
            { op: '-', fn: (a, b) => a - b, maxA: 50, maxB: 30 },
            { op: '×', fn: (a, b) => a * b, maxA: 12, maxB: 8 },
            { op: '÷', fn: (a, b) => a * b, maxA: 12, maxB: 8 }
          ];
          
          const operation = operations[Math.floor(Math.random() * operations.length)];
          const a = Math.floor(Math.random() * operation.maxA) + 1;
          const b = Math.floor(Math.random() * operation.maxB) + 1;
          
          let question, answer;
          
          if (operation.op === '÷') {
            question = `${a * b} ÷ ${b} = ?`;
            answer = a.toString();
          } else {
            question = `${a} ${operation.op} ${b} = ?`;
            answer = operation.fn(a, b).toString();
          }
          
          return { text: question, answer };
        };
  
        // Modal açıldığında captcha oluştur
        useEffect(() => {
          if (props.show) {
            setCaptchaData(generateAdvancedCaptcha());
            setUserCaptchaInput("");
            setCaptchaAttempts(0);
            setIsBlocked(false);
            setBlockUntil(0);
          }
        }, [props.show]);
  
        const validateCaptcha = (input) => {
          // Blok kontrolü
          if (isBlocked && Date.now() < blockUntil) {
            const remainingTime = Math.ceil((blockUntil - Date.now()) / 1000);
            alert(`Çok fazla deneme! ${remainingTime} saniye bekleyin.`);
            return false;
          }
          
          // Rate limiting
          const now = Date.now();
          if (now - lastSubmission < 30000) { // 30 saniye
            alert("Çok hızlı gönderim! 30 saniye bekleyin.");
            return false;
          }
          
          // Captcha doğrulama
          if (input.trim() !== captchaData.answer) {
            setCaptchaAttempts(prev => prev + 1);
            
            if (captchaAttempts >= 2) { // 3 deneme hakkı
              setIsBlocked(true);
              setBlockUntil(now + 300000); // 5 dakika blok
              setCaptchaAttempts(0);
              alert("Çok fazla hatalı deneme! 5 dakika bekleyin.");
            } else {
              alert(`Yanlış cevap! ${2 - captchaAttempts} deneme hakkınız kaldı.`);
            }
            return false;
          }
          
          // Başarılı
          setCaptchaAttempts(0);
          return true;
        };
  
        const saveComment = async()=>{
          if (!validateCaptcha(userCaptchaInput)) {
            return;
          }
          
          const data = { 
            nameSurname,
            mail,
            phone,
            comment,
            itemId : item.id
          }
  
          if(nameSurname.length>0 && mail.length>0 && comment.length>1)
          {
            const res = await postCommentItem(data);
            if(res.status)
            {
              alert("Mesaj gönderme başarılı");
              // Form alanlarını temizle
              setNameSurname("");
              setMail("");
              setPhone("");
              setComment("");
              // Captcha'yı yenile
              setCaptchaData(generateAdvancedCaptcha());
              setUserCaptchaInput("");
              setLastSubmission(Date.now());
              props.onHide();
            }
          }
          else
          {
            alert("Mesaj Gönderme başarısız" )
          }
        }
  
        return (
          <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                {config.project.name} Madde Mesaj Formu
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Alert variant="warning" className="mb-3">
                Bu formun yalnızca <strong>{item.title} </strong> 
                maddesi ile ilgili mesajlar için kullanılması, TÜGİKİP Ansiklopedisi'ne ilişkin diğer hususların 
                <a href="/iletisim"> İletişim Formu</a> üzerinden iletilmesi rica
                olunur.
              </Alert>
  
              <Form method="POST">
                <Form.Group className="mb-3">
                  <Form.Label>Mesajınız*</Form.Label>
                  <Form.Control
                    as="textarea"
                    placeholder="Ayrıntılı olarak mesajınızı yazınız."
                    rows={2}
                    onChange={e=>setComment(e.target.value)}
                    value={comment}
                  />
                </Form.Group>
                
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <Form.Label>Ad Soyad*</Form.Label>
                      <Form.Control 
                        type="text"  
                        onChange={e=>setNameSurname(e.target.value)} 
                        value={nameSurname} 
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <Form.Label>E-posta*</Form.Label>
                      <Form.Control 
                        type="email" 
                        onChange={e=>setMail(e.target.value)}  
                        value={mail} 
                        placeholder="isim@ornek.com" 
                      />
                    </Form.Group>
                  </div>
                </div>
  
                <Form.Group className="mb-3">
                  <Form.Label>Telefon</Form.Label>
                  <Form.Control 
                    type="number" 
                    onChange={e=>setPhone(e.target.value)}  
                    value={phone} 
                    placeholder="05XXXXXXXXX" 
                  />
                </Form.Group>
  
                <div className="captcha-container">
                  <div className="captcha-box">
                    <span>Doğrulama: </span>
                    <span className="captcha-question">{captchaData.text}</span>
                    <button 
                      type="button" 
                      className="btn btn-sm btn-outline-secondary ms-2"
                      onClick={() => setCaptchaData(generateAdvancedCaptcha())}
                      title="Yeni soru oluştur"
                    >
                      🔄
                    </button>
                  </div>
                  <Form.Control
                    type="text"
                    placeholder="Cevabı girin"
                    value={userCaptchaInput}
                    onChange={(e) => setUserCaptchaInput(e.target.value)}
                  />
                </div>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={props.onHide} variant="secondary">
                Kapat
              </Button>
              <Button onClick={()=>saveComment()} variant="danger" className="text-white">
                Gönder
              </Button>
            </Modal.Footer>
          </Modal>
        );
      };
    
    const CITATION_STYLES = [
        { id: 'mla', label: 'MLA 9' },
        { id: 'chicago', label: 'Chicago 18' },
        { id: 'apa', label: 'APA 7' },
        { id: 'isnad', label: 'İSNAD 2' },
    ];

    const getShareUrl = () => {
        const isLocal = (value) => /localhost|127\.0\.0\.1/i.test(String(value || ''));
        const currentOrigin = typeof window !== 'undefined' ? window.location.origin : '';
        const configOrigin = String(config.appUrl || '').replace(/\/$/, '');
        const publicOrigin = 'https://tugikip.gov.tr';
        const origin = String(
            (!isLocal(currentOrigin) && currentOrigin)
            || (!isLocal(configOrigin) && configOrigin)
            || publicOrigin
        ).replace(/\/$/, '');
        if (item?.id) {
            const slug = titleUrlDeleteBaskSpace(item.title || '');
            return slug
                ? `${origin}/detay/${item.id}/${encodeURIComponent(slug)}`
                : `${origin}/detay/${item.id}`;
        }
        return !isLocal(currentOrigin) && typeof window !== 'undefined'
            ? window.location.href
            : publicOrigin;
    };
    const getShareTitle = () => (item.title || '').trim();
    const formatTrLongDate = (date) =>
        date.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });
    const getPublishYear = () => {
        const parsed = item.releaseDate ? new Date(item.releaseDate) : null;
        return parsed && !Number.isNaN(parsed.getTime()) ? parsed.getFullYear() : new Date().getFullYear();
    };
    const getCitationAuthors = () =>
        (item.writerName || config.project.name || '')
            .replace(/,/g, ', ')
            .replace(/\s+/g, ' ')
            .trim();

    const getCitationText = (style) => {
        const authors = getCitationAuthors();
        const title = getShareTitle();
        const publisher = config.project.name;
        const url = getShareUrl();
        const year = getPublishYear();
        const accessed = formatTrLongDate(new Date());
        if (style === 'apa') {
            return `${authors} (${year}). ${title}. ${publisher}. ${url}`;
        }
        if (style === 'chicago') {
            return `${authors}. "${title}." ${publisher}. Erişim ${accessed}. ${url}.`;
        }
        if (style === 'isnad') {
            return `${authors}, "${title}", ${publisher} (Erişim ${accessed}), ${url}.`;
        }
        return `${authors}. "${title}." ${publisher}, Erişim ${accessed}, ${url}.`;
    };

    const copyCitation = async () => {
        try {
            await navigator.clipboard.writeText(getCitationText(citationStyle));
            setCitationCopied(true);
            setTimeout(() => setCitationCopied(false), 1800);
        } catch (_) {
            /* ignore */
        }
    };

    // Image modal fonksiyonları
    const handleImageClick = (image, index) => {
        setSelectedImage(image);
        setCurrentImageIndex(index);
        setShowImageModal(true);
    };

    const handleCloseImageModal = () => {
        setShowImageModal(false);
        setSelectedImage(null);
        setCurrentImageIndex(0);
        setImageScale(1);
        setImagePosition({ x: 0, y: 0 });
    };

    // Zoom fonksiyonları
    const handleZoomIn = () => {
        setImageScale(prev => Math.min(prev * 1.2, 5)); // Max 5x zoom
    };

    const handleZoomOut = () => {
        setImageScale(prev => Math.max(prev / 1.2, 0.5)); // Min 0.5x zoom
    };

    const handleZoomReset = () => {
        setImageScale(1);
        setImagePosition({ x: 0, y: 0 });
    };

    const handleImageDoubleClick = () => {
        if (imageScale === 1) {
            setImageScale(2);
        } else {
            handleZoomReset();
        }
    };

    // Mouse wheel zoom
    const handleWheel = (e) => {
        e.preventDefault();
        const delta = e.deltaY > 0 ? 0.9 : 1.1;
        setImageScale(prev => Math.min(Math.max(prev * delta, 0.5), 5));
    };

    // Drag fonksiyonları (zoom'lanmış resmi kaydırma için)
    const handleMouseDown = (e) => {
        if (imageScale > 1) {
            setIsDragging(true);
            setDragStart({
                x: e.clientX - imagePosition.x,
                y: e.clientY - imagePosition.y
            });
        }
    };

    const handleMouseMove = (e) => {
        if (isDragging && imageScale > 1) {
            setImagePosition({
                x: e.clientX - dragStart.x,
                y: e.clientY - dragStart.y
            });
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const goToPreviousImage = () => {
        const newIndex = currentImageIndex > 0 ? currentImageIndex - 1 : imageList.length - 1;
        setCurrentImageIndex(newIndex);
        setSelectedImage(imageList[newIndex]);
        // Reset zoom when changing images
        setImageScale(1);
        setImagePosition({ x: 0, y: 0 });
    };

    const goToNextImage = () => {
        const newIndex = currentImageIndex < imageList.length - 1 ? currentImageIndex + 1 : 0;
        setCurrentImageIndex(newIndex);
        setSelectedImage(imageList[newIndex]);
        // Reset zoom when changing images
        setImageScale(1);
        setImagePosition({ x: 0, y: 0 });
    };

    const getVideoCaption = (video, index = 0) => {
        const title = (video?.docTypeTitle || '').trim();
        if (title) return title;
        const name = (video?.originalName || '').replace(/\.[^/.]+$/, '').trim();
        if (name) return name;
        return `Video ${index + 1}`;
    };

    const getMediaSource = (media) => (media?.source || '').trim();

    const itemWriters = (() => {
        if (Array.isArray(item.writerList) && item.writerList.length) {
            return item.writerList
                .map((writer) => ({
                    id: writer.id || writer.userId,
                    name: (writer.name || [writer.name, writer.surname].filter(Boolean).join(' ')).trim()
                }))
                .filter((writer) => writer.name);
        }
        const names = (item.writerName || '').split(',').map((name) => name.trim()).filter(Boolean);
        const ids = String(item.userIdList || item.userId || '')
            .split(',')
            .map((id) => id.trim())
            .filter(Boolean);
        return names.map((name, index) => ({
            id: ids[index] || item.userId,
            name
        }));
    })();

    const keywordList = (item.keyword || '')
        .split(/[,;]+/)
        .map((k) => k.trim())
        .filter(Boolean);
    const bibliography = (item.sourceText || '').replace(/\u00a0/g, ' ').trim();
    const bibliographyIsHtml = /<[a-z][\s\S]*>/i.test(bibliography);
    const bibliographyEntries = (() => {
        if (!bibliography) return [];
        if (bibliographyIsHtml && typeof document !== 'undefined') {
            const tpl = document.createElement('template');
            tpl.innerHTML = stripInlineFontFamilyFromHtml(bibliography);
            const blocks = tpl.content.querySelectorAll('p, li');
            const fromBlocks = Array.from(blocks).flatMap((el) =>
                el.innerHTML
                    .replace(/\u00a0/g, ' ')
                    .split(/(?:<br\s*\/?>\s*){2,}/i)
                    .map((part) => part.replace(/(?:<br\s*\/?>\s*)+/gi, ' ').trim())
                    .filter((html) => html.replace(/<[^>]+>/g, '').replace(/\s+/g, '').length > 0)
            );
            if (fromBlocks.length) return fromBlocks;
        }
        return bibliography
            .replace(/<\/(?:p|div|li)>/gi, '\n')
            .replace(/<br\s*\/?>/gi, '\n')
            .replace(/<[^>]+>/g, '')
            .split(/\n\s*\n+/)
            .map((entry) => entry.replace(/\s+/g, ' ').trim())
            .filter(Boolean);
    })();

    const sourceTooltip = (id, source) => (
        <Tooltip id={`media-source-${id}`} className="article-source-tooltip">
            <div className="article-source-tooltip__label">Kaynakça</div>
            <div>{source}</div>
        </Tooltip>
    );

    const withSourceTooltip = (media, index, node) => {
        const source = getMediaSource(media);
        if (!source) return node;
        return (
            <OverlayTrigger
                placement="left"
                delay={{ show: 150, hide: 80 }}
                overlay={sourceTooltip(media.id || index, source)}
            >
                {node}
            </OverlayTrigger>
        );
    };

    const pauseModalVideo = () => {
        if (videoPlayerRef.current) {
            videoPlayerRef.current.pause();
            videoPlayerRef.current.currentTime = 0;
        }
    };

    const handleVideoClick = (video, index) => {
        setSelectedVideo(video);
        setCurrentVideoIndex(index);
        setShowVideoModal(true);
    };

    const handleCloseVideoModal = () => {
        pauseModalVideo();
        setShowVideoModal(false);
        setSelectedVideo(null);
        setCurrentVideoIndex(0);
    };

    const goToPreviousVideo = () => {
        if (!videoList.length) return;
        pauseModalVideo();
        const newIndex = currentVideoIndex > 0 ? currentVideoIndex - 1 : videoList.length - 1;
        setCurrentVideoIndex(newIndex);
        setSelectedVideo(videoList[newIndex]);
    };

    const goToNextVideo = () => {
        if (!videoList.length) return;
        pauseModalVideo();
        const newIndex = currentVideoIndex < videoList.length - 1 ? currentVideoIndex + 1 : 0;
        setCurrentVideoIndex(newIndex);
        setSelectedVideo(videoList[newIndex]);
    };

    // Keyboard navigation için
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (showVideoModal) {
                switch (event.key) {
                    case 'Escape':
                        handleCloseVideoModal();
                        break;
                    case 'ArrowLeft':
                        goToPreviousVideo();
                        break;
                    case 'ArrowRight':
                        goToNextVideo();
                        break;
                    default:
                        break;
                }
                return;
            }
            if (showImageModal) {
                switch (event.key) {
                    case 'Escape':
                        handleCloseImageModal();
                        break;
                    case 'ArrowLeft':
                        goToPreviousImage();
                        break;
                    case 'ArrowRight':
                        goToNextImage();
                        break;
                    case '+':
                    case '=':
                        handleZoomIn();
                        break;
                    case '-':
                        handleZoomOut();
                        break;
                    case '0':
                        handleZoomReset();
                        break;
                    default:
                        break;
                }
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [showImageModal, currentImageIndex, showVideoModal, currentVideoIndex]);

    const citation = getCitationText(citationStyle);

    return (
        <div className="article-detail-container">
            <div className="article-detail-layout">
                {/* İlgili Makaleler - Sol Sidebar */}
                <div className="related-articles-sidebar">
                    <h3 className="related-articles-title">İlgili Makaleler</h3>
                    <div className="related-articles-list">
                        {relationItemList.map((relatedItem, index) => (
                            <Link 
                                key={index} 
                                to={getDetailLink(relatedItem)} 
                                className="related-article-item"
                            >
                                <div className="related-article-thumbnail">
                                    <img 
                                        src={relatedItem.primaryImage || "/images/tugikip/TUGIKIP_LOGOLAR_1.jpg"} 
                                        alt={relatedItem.title}
                                        className="related-article-image"
                                    />
                                </div>
                                <div className="related-article-content">
                                    <h4 className="related-article-title">{relatedItem.title}</h4>
                                    <p className="related-article-author">{relatedItem.writerName ? relatedItem.writerName.replace(/,/g, ',\n') : ''}</p>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>

                {/* Ana İçerik - Orta */}
                <div className="article-content-main" style={{ backgroundColor: readingBgColor }}>
                    <div className="article-main-toolbar">
                        <div className="article-actions article-actions--in-toolbar">
                            <div className="article-actions__reading">
                                {readingPanelOpen ? (
                                    <div className="article-reading-panel article-reading-panel--compact" role="dialog" aria-label="Okuma ayarları">
                                        <div className="article-reading-panel__sizes">
                                            <button
                                                type="button"
                                                className="article-reading-panel__font-btn"
                                                onClick={() => adjustReadingFontSize(-1)}
                                                disabled={customFontSize <= READING_FONT_MIN}
                                                aria-label="Yazı boyutunu küçült"
                                                title="Küçült"
                                            >
                                                A<span className="article-reading-panel__tri">▼</span>
                                            </button>
                                            <button
                                                type="button"
                                                className="article-reading-panel__font-btn"
                                                onClick={() => adjustReadingFontSize(1)}
                                                disabled={customFontSize >= READING_FONT_MAX}
                                                aria-label="Yazı boyutunu büyüt"
                                                title="Büyüt"
                                            >
                                                A<span className="article-reading-panel__tri">▲</span>
                                            </button>
                                        </div>
                                        <div className="article-reading-panel__divider" aria-hidden />
                                        <div className="article-reading-panel__themes">
                                            {READING_THEMES.map((theme) => (
                                                <button
                                                    key={theme.id}
                                                    type="button"
                                                    data-theme={theme.id}
                                                    className={`article-reading-panel__theme-swatch ${readingThemeId === theme.id ? 'active' : ''}`}
                                                    style={{ backgroundColor: theme.color }}
                                                    onClick={() => setReadingThemeId(theme.id)}
                                                    aria-label={theme.id === 'white' ? 'Beyaz arka plan' : 'Krem arka plan'}
                                                    title={theme.id === 'white' ? 'Beyaz' : 'Krem'}
                                                />
                                            ))}
                                        </div>
                                        <div className="article-reading-panel__divider" aria-hidden />
                                        <button
                                            type="button"
                                            className="article-reading-panel__close"
                                            onClick={() => setReadingPanelOpen(false)}
                                        >
                                            Kapat
                                        </button>
                                    </div>
                                ) : (
                                    <button
                                        type="button"
                                        className="article-reading-panel-open article-reading-panel-open--compact"
                                        onClick={() => setReadingPanelOpen(true)}
                                        aria-label="Okuma ayarlarını aç"
                                        title="Okuma ayarları"
                                    >
                                        Aa
                                    </button>
                                )}
                            </div>
                            <div className="article-actions__tools">
                                <img src="/images/tugikip/yazici.png" alt="Print" className="action-icon" onClick={handlePrint} />
                                <div 
                                    className={`pdf-download-button ${isPdfDownloading ? 'downloading' : ''}`} 
                                    onClick={() => !isPdfDownloading && onClickDownload("PDF","tr")}
                                    title={isPdfDownloading ? "PDF indiriliyor..." : "Bu maddeyi PDF olarak indir"}
                                >
                                    {isPdfDownloading ? (
                                        <svg className="action-icon pdf-loading-icon" viewBox="0 0 24 24" fill="currentColor">
                                            <circle cx="12" cy="12" r="3" opacity="0.1"/>
                                            <path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity="0.25"/>
                                            <path d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z">
                                                <animateTransform attributeName="transform" dur="0.75s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12"/>
                                            </path>
                                        </svg>
                                    ) : (
                                        <svg className="action-icon pdf-download-icon" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                                            <text x="12" y="17" textAnchor="middle" fontSize="7" fill="currentColor" fontWeight="bold">PDF</text>
                                        </svg>
                                    )}
                                </div>
                                <img src="/images/tugikip/kunye.png" alt="Info" className="action-icon" onClick={() => setShowInfo(true)} />
                                <img 
                                      src="/images/tugikip/alinti.png" 
                                      alt="Alıntıla" 
                                      className="action-icon"
                                      title="Alıntıla"
                                      onClick={() => {
                                          setCitationCopied(false);
                                          setShowQuote(true);
                                      }}
                                  />
                                <div 
                                  className="feedback-button" 
                                  onClick={() => setModalShow(true)}
                                  title="Bu madde hakkında bildirimde bulunun"
                                >
                                  <svg className="action-icon feedback-icon" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M20,4H4C2.9,4,2,4.9,2,6V18C2,19.1,2.9,20,4,20H20C21.1,20,22,19.1,22,18V6C22,4.9,21.1,4,20,4M20,8L12,13L4,8V6L12,11L20,6V8Z" />
                                  </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="article-reading-zone" style={{ fontSize: `${customFontSize}px` }}>
                        <div className="article-detail-header">
                            <h1 className="article-detail-title">{item.title}</h1>
                            <h2 className="article-detail-subtitle">{item.definition}</h2>
                        </div>

                        <div className="article-detail-author pt-5">
                            <div className="article-author-detail-info">
                                <div className="author-detail-frame">
                                    <span className="article-author-detail-name">
                                        {itemWriters.map((writer, index) => (
                                            <React.Fragment key={writer.id || `${writer.name}-${index}`}>
                                                {index > 0 ? ',\n' : null}
                                                {writer.id ? (
                                                    <Link to={`/yazar/${writer.id}`}>{writer.name}</Link>
                                                ) : (
                                                    writer.name
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </span>
                                    <span className="article-detail-pen-icon" aria-hidden="true">
                                        <svg viewBox="0 0 24 24" fill="none">
                                            <path
                                                d="M14.1 4.3c.4-.4 1-.4 1.4 0l4.2 4.2c.4.4.4 1 0 1.4l-9.2 9.2c-.2.2-.4.3-.7.3l-4.3.7c-.6.1-1.1-.4-1-.1l.7-4.3c0-.3.1-.5.3-.7l9.2-9.2z"
                                                fill="#fff"
                                            />
                                            <path d="M13.2 6.2 17.8 10.8" stroke="#A91916" strokeWidth="1.2" />
                                        </svg>
                                    </span>
                                </div>
                                <div className="author-detail-institution">
                                    {/* {item.inst} */}
                                    {/* {articleInfo.department && `, ${articleInfo.department}`} */}
                                </div>
                                {/* {articleInfo.email && (
                                <div className="author-detail-email">
                                    {articleInfo.email}
                                </div>
                            )} */}
                            </div>
                        </div>

                        <div 
                            className="article-detail-text pt-3"
                            dangerouslySetInnerHTML={{ __html: stripInlineFontFamilyFromHtml(item.itemText) }}
                        />

                        {(keywordList.length > 0 || bibliographyEntries.length > 0) && (
                            <div className="article-meta-sections">
                                {keywordList.length > 0 && (
                                    <section className="article-meta-section" aria-label="Anahtar kelimeler">
                                        <h3 className="article-meta-title">Anahtar Kelimeler</h3>
                                        <div className="article-keywords">
                                            {keywordList.map((keyword) => (
                                                <Link
                                                    key={keyword}
                                                    to={`/gelismisArama?keyword=${encodeURIComponent(keyword)}`}
                                                    className="article-keyword"
                                                >
                                                    {keyword}
                                                </Link>
                                            ))}
                                        </div>
                                    </section>
                                )}
                                {bibliographyEntries.length > 0 && (
                                    <section className="article-meta-section" aria-label="Kaynakça">
                                        <h3 className="article-meta-title">Kaynakça</h3>
                                        <ul className="article-bibliography-list">
                                            {bibliographyEntries.map((entry, index) => (
                                                bibliographyIsHtml ? (
                                                    <li
                                                        key={index}
                                                        dangerouslySetInnerHTML={{
                                                            __html: stripInlineFontFamilyFromHtml(entry)
                                                        }}
                                                    />
                                                ) : (
                                                    <li key={index}>{entry}</li>
                                                )
                                            ))}
                                        </ul>
                                    </section>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                {/* Videolar ve resimler - Sağ Sidebar */}
                <div className="article-images-sidebar">
                    {videoList.map((video, index) => {
                        const source = getMediaSource(video);
                        return (
                            <React.Fragment key={video.id || index}>
                                {withSourceTooltip(video, index, (
                                    <figure className="article-detail-figure article-video-figure">
                                        <button
                                            type="button"
                                            className="article-video-thumb"
                                            onClick={() => handleVideoClick(video, index)}
                                            aria-label={`${getVideoCaption(video, index)} videosunu oynat`}
                                        >
                                            <span className="article-video-play" aria-hidden="true">
                                                <svg viewBox="0 0 24 24" fill="currentColor">
                                                    <path d="M8 5v14l11-7z" />
                                                </svg>
                                            </span>
                                        </button>
                                        <figcaption>
                                            {getVideoCaption(video, index)}
                                            {source ? <span className="article-figure-source-hint" aria-hidden="true">i</span> : null}
                                        </figcaption>
                                    </figure>
                                ))}
                            </React.Fragment>
                        );
                    })}
                    {imageList.map((image, index) => {
                        const source = getMediaSource(image);
                        return (
                            <React.Fragment key={image.id || index}>
                                {withSourceTooltip(image, index, (
                                    <figure className="article-detail-figure">
                                        <img
                                            src={image.url}
                                            alt={image.docTypeTitle}
                                            onClick={() => handleImageClick(image, index)}
                                            style={{ cursor: 'pointer' }}
                                        />
                                        <figcaption>
                                            {image.docTypeTitle}
                                            {source ? <span className="article-figure-source-hint" aria-hidden="true">i</span> : null}
                                        </figcaption>
                                    </figure>
                                ))}
                            </React.Fragment>
                        );
                    })}
                </div>
            </div>

            {/* Info Modal */}
            <Modal show={showInfo} onHide={() => setShowInfo(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Madde Künyesi</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="article-info">
                        <p><strong>Yazar:</strong> {item.writerName ? item.writerName.replace(/,/g, ',\n') : ''}</p>
                        <p><strong>Başlık:</strong> {item.title}</p>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Quote Modal */}
            <Modal
                show={showQuote}
                onHide={() => setShowQuote(false)}
                centered
                className="share-cite-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Alıntıla</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="share-cite-section">
                        <div className="share-cite-styles" role="tablist" aria-label="Alıntı stili">
                            {CITATION_STYLES.map((style) => (
                                <button
                                    key={style.id}
                                    type="button"
                                    role="tab"
                                    aria-selected={citationStyle === style.id}
                                    className={`share-cite-style ${citationStyle === style.id ? 'active' : ''}`}
                                    onClick={() => {
                                        setCitationStyle(style.id);
                                        setCitationCopied(false);
                                    }}
                                >
                                    {style.label}
                                </button>
                            ))}
                        </div>
                        <div className="share-cite-box">
                            <p className="share-cite-text">{citation}</p>
                            <button
                                type="button"
                                className="share-cite-copy"
                                onClick={copyCitation}
                                aria-label="Alıntıyı kopyala"
                                title="Kopyala"
                            >
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                                    <rect x="8" y="8" width="12" height="12" rx="2" />
                                    <path d="M4 16V6a2 2 0 0 1 2-2h10" />
                                </svg>
                            </button>
                        </div>
                        {citationCopied ? <p className="share-cite-notice">Alıntı kopyalandı.</p> : null}
                    </div>
                </Modal.Body>
            </Modal>

            {/* Image Modal */}
            <Modal 
                show={showImageModal} 
                onHide={handleCloseImageModal} 
                centered 
                size="xl"
                className="image-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {selectedImage?.docTypeTitle}
                        {imageList.length > 1 && (
                            <small className="ms-2">({currentImageIndex + 1} / {imageList.length})</small>
                        )}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body 
                    className="text-center p-0 position-relative"
                    onMouseMove={handleMouseMove}
                    onMouseUp={handleMouseUp}
                    onMouseLeave={handleMouseUp}
                    onWheel={handleWheel}
                    style={{ overflow: 'hidden', cursor: isDragging ? 'grabbing' : (imageScale > 1 ? 'grab' : 'default') }}
                >
                    {selectedImage && (
                        <>
                            <img 
                                src={selectedImage.url} 
                                alt={selectedImage.docTypeTitle}
                                onDoubleClick={handleImageDoubleClick}
                                onMouseDown={handleMouseDown}
                                style={{
                                    maxWidth: imageScale === 1 ? '100%' : `${100 * imageScale}%`,
                                    maxHeight: imageScale === 1 ? '100%' : `${100 * imageScale}%`,
                                    width: imageScale === 1 ? 'auto' : 'auto',
                                    height: imageScale === 1 ? 'auto' : 'auto',
                                    objectFit: 'contain',
                                    transform: `scale(${imageScale}) translate(${imagePosition.x}px, ${imagePosition.y}px)`,
                                    transition: isDragging ? 'none' : 'transform 0.2s ease',
                                    cursor: imageScale > 1 ? 'grab' : 'zoom-in',
                                    userSelect: 'none',
                                    pointerEvents: 'auto'
                                }}
                                draggable={false}
                            />
                            
                            {/* Navigation buttons */}
                            {imageList.length > 1 && (
                                <>
                                    <button
                                        onClick={goToPreviousImage}
                                        className="image-nav-btn image-nav-prev"
                                        aria-label="Önceki resim"
                                    >
                                        &#8249;
                                    </button>
                                    <button
                                        onClick={goToNextImage}
                                        className="image-nav-btn image-nav-next"
                                        aria-label="Sonraki resim"
                                    >
                                        &#8250;
                                    </button>
                                </>
                            )}
                            
                            {/* Zoom controls */}
                            <div className="zoom-controls">
                                <button
                                    onClick={handleZoomOut}
                                    className="zoom-btn zoom-out"
                                    disabled={imageScale <= 0.5}
                                    aria-label="Uzaklaştır"
                                >
                                    −
                                </button>
                                <span className="zoom-level">{Math.round(imageScale * 100)}%</span>
                                <button
                                    onClick={handleZoomIn}
                                    className="zoom-btn zoom-in"
                                    disabled={imageScale >= 5}
                                    aria-label="Yakınlaştır"
                                >
                                    +
                                </button>
                                <button
                                    onClick={handleZoomReset}
                                    className="zoom-btn zoom-reset"
                                    disabled={imageScale === 1 && imagePosition.x === 0 && imagePosition.y === 0}
                                    aria-label="Sıfırla"
                                >
                                    ⌂
                                </button>
                            </div>
                        </>
                    )}
                </Modal.Body>
                {(selectedImage?.docTypeTitle || getMediaSource(selectedImage)) && (
                    <Modal.Footer className="justify-content-center">
                        {selectedImage?.docTypeTitle && (
                            <small className="text-muted">{selectedImage.docTypeTitle}</small>
                        )}
                        {getMediaSource(selectedImage) && (
                            <small className="article-modal-source">Kaynakça: {getMediaSource(selectedImage)}</small>
                        )}
                        <div className="d-flex flex-wrap justify-content-center gap-3 mt-2">
                            {imageList.length > 1 && (
                                <small className="text-muted">
                                    📱 Gezinme: ← → tuşları
                                </small>
                            )}
                            <small className="text-muted">
                                🔍 Yakınlaştırma: +/- tuşları veya çift tıklama
                            </small>
                            <small className="text-muted">
                                ✋ Kaydırma: Zoom'lanmış resmi sürükleyin
                            </small>
                        </div>
                    </Modal.Footer>
                )}
            </Modal>

            {/* Video Modal */}
            <Modal
                show={showVideoModal}
                onHide={handleCloseVideoModal}
                centered
                size="xl"
                className="image-modal video-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {selectedVideo ? getVideoCaption(selectedVideo, currentVideoIndex) : 'Video'}
                        {videoList.length > 1 && (
                            <small className="ms-2">({currentVideoIndex + 1} / {videoList.length})</small>
                        )}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center p-0 position-relative video-modal-body">
                    {selectedVideo && (
                        <>
                            <video
                                key={selectedVideo.id || selectedVideo.url}
                                ref={videoPlayerRef}
                                src={selectedVideo.url}
                                controls
                                autoPlay
                                playsInline
                                className="article-video-player"
                            >
                                Tarayıcınız video oynatmayı desteklemiyor.
                            </video>
                            {videoList.length > 1 && (
                                <>
                                    <button
                                        type="button"
                                        onClick={goToPreviousVideo}
                                        className="image-nav-btn image-nav-prev"
                                        aria-label="Önceki video"
                                    >
                                        &#8249;
                                    </button>
                                    <button
                                        type="button"
                                        onClick={goToNextVideo}
                                        className="image-nav-btn image-nav-next"
                                        aria-label="Sonraki video"
                                    >
                                        &#8250;
                                    </button>
                                </>
                            )}
                        </>
                    )}
                </Modal.Body>
            </Modal>

               {/* Geri Bildirim Modalı */}
               <FeedbackModal
              show={modalShow}
              onHide={() => setModalShow(false)}
              item={item}
            />
        </div>
    );
};

export default ArticleDetail; 